const keyToPathMap = {
  register: { path: "register", icon: "" },
  organization_approval: { path: "organization_approval", icon: "" },
  organization_manager: { path: "organization_manager", icon: "" },
  issuer_manager: { path: "issuer_manager", icon: "" },
  new_affiliates: { path: "new_affiliates", icon: "" },
  public_home: { path: "", icon: "" },
  user_dashboard: { path: "user_dashboard", icon: "" },
  home: { path: "", icon: "fa-home" },
  supervisory: { path: "", icon: "fa-solid fa-user-tie" },
  Valuation: { path: "", icon: "fa-solid fa-search-dollar" },
  document_manager: { path: "document_manager", icon: "" },
  product_management: { path: "product_management", icon: "" },
  product_manager: { path: "product_manager", icon: "" },
  bulk_manager: { path: "bulk_manager", icon: "" },
  Instruments: { path: "", icon: "fa-solid fa-money-bill" },
  news_category_manager: { path: "news_category_manager", icon: "" },
  excluded_symbols_manager: { path: "excluded_symbols_manager", icon: "" },
  daily_list_approval: { path: "daily_list_approval", icon: "" },
  audit_logs: { path: "audit_logs", icon: "" },
  contacts: { path: "contacts", icon: "" },
  users: { path: "users", icon: "" },
  property_manager: { path: "", icon: "fa-solid fa-key" },
  "property_manager/AssetFocus": { path: "property_manager/AssetFocus", icon: "" },
  "property_manager/PeerGroup": { path: "property_manager/PeerGroup", icon: "" },
  "property_manager/EquitySingleSector": { path: "property_manager/EquitySingleSector", icon: "" },
  "property_manager/FundInvestmentCategory": { path: "property_manager/FundInvestmentCategory", icon: "" },
  "property_manager/IndustryAlignment": { path: "property_manager/IndustryAlignment", icon: "" },
  "property_manager/InvestmentFocus": { path: "property_manager/InvestmentFocus", icon: "" },
  "property_manager/ManagementOversight": { path: "property_manager/ManagementOversight", icon: "" },
  "property_manager/NonTradedReitStructure": { path: "property_manager/NonTradedReitStructure", icon: "" },
  "property_manager/InstrumentClass": { path: "property_manager/InstrumentClass", icon: "" },
  "property_manager/FactorWeightingScheme": { path: "property_manager/FactorWeightingScheme", icon: "" },
  instrument_manager: { path: "instrument_manager?instrumentMode=New&action=NEWAPP", icon: "" },
  batch_application_upload: { path: "batch_application_upload", icon: "" },
  awaiting_completion: { path: "awaiting_completion", icon: "" },
  pending_approval: { path: "pending_approval", icon: "" },
  live_instruments: { path: "live_instruments", icon: "" },
  deleted_instruments: { path: "deleted_instruments", icon: "" },
  instrument_history: { path: "instrument_history", icon: "" },
  instrument_expense_manager: { path: "instrument_expense_manager", icon: "" },
  product_fix: { path: "product_fix", icon: "" },
  downloads: { path: "", icon: "fa-solid fa-download" },
  document_repository: { path: "document_repository", icon: "" },
  daily_list_download: { path: "daily_list_download", icon: "" },
  symbol_generator: { path: "symbol_generator", icon: "" },
  product_download: { path: "product_download", icon: "" },
  billing_contacts_report: { path: "billing_contacts_report", icon: "" },
  market_close_calendar: { path: "market_close_calendar", icon: "" },
  service_access_key: { path: "service_access_key", icon: "" },
  symbol_directory: { path: "symbol_directory", icon: "" },
  batch_expense_upload: { path: "batch_expense_upload", icon: "" },
  doc_download: { path: "doc_download", icon: "" },
  reconciliation_report: { path: "reconciliation_report", icon: "" },
  portfolio_setup: { path: "portfolio_setup", icon: "" },
  content_management_system: { path: "content_management_system", icon: "" }
}

export default keyToPathMap
